import { createTheme as createThemeV5 } from '@mui/material/styles';
import palette from './palette';
import typography from './typography';
import * as v5 from './v5';

export const themeV5 = createThemeV5({
  palette,
  typography,
  components: v5,
});

// For backwards compatibility during migration
export const themeV4 = themeV5;
